import { render, staticRenderFns } from "./CallForwardingSetting.vue?vue&type=template&id=cb75c290&"
import script from "./CallForwardingSetting.vue?vue&type=script&lang=js&"
export * from "./CallForwardingSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports